export default {
  language: {
    language: 'language',
    zh: 'china',
    en: 'english'
  }
};



// WEBPACK FOOTER //
// ./src/lang/en.js